import { useEffect } from 'react';
import { useWorkflowSocket } from '../../features/workflow/hub/useWorkflowSocket';

export const ConnectionChange = () => {
  const update = useWorkflowSocket((r) => r.data?.updateConnectionType);
  const invoke = useWorkflowSocket((r) => r.invoke);
  useEffect(() => {
    if (update) {
      invoke('UpdateConnectionType');
    }
  }, [update, invoke]);

  return <></>;
};
